<template>
  <!-- LOGO REPUBLIQUE FRANCAISE -->
  <router-link
    class="bloc-entite-servicielle-clir link-unstyled active-color-unstyled"
    href="#"
    tag="a"
    to="/"
  >
    <img
      v-if="blocMarqueShow"
      class="bloc-marque-clir"
      :src="handleImage(blocMarqueSrc)"
      alt="Logo République Française"
    />
    <span class="bloc-logotype-clir align-self-center d-flex flex-column flex-fill align-items-start">
      <!-- LOGO APPLICATIF -->
      <img
        v-if="logoShow"
        :src="handleImage(logoSrc)"
        :class="logoClass"
        :alt="logoAltText"
        :style="logoStyle"
      />
      <slot v-else-if="customBlocLogotypeShow" name="customBlocLogotype" />
    </span>
  </router-link>
</template>

<script>
export default {
  name: "EntiteServicielle",
  props: {
    blocMarqueConfig: { type: Object, default: () => {} },
    logoConfig: { type: Object, default: () => {} }
  },
  computed: {
    blocMarqueShow() {
      return this.getKey(this.blocMarqueConfig, "show", false);
    },
    blocMarqueSrc() {
      return this.getKey(this.blocMarqueConfig, "src", "");
    },
    logoShow() {
      return (
        !!this.getKey(this.logoConfig, "show", false) && this.logoSrc.length > 0
      );
    },
    customBlocLogotypeShow() {
      return (
        !!this.$slots.customBlocLogotype ||
        !!this.$scopedSlots.customBlocLogotype
      );
    },
    logoSrc() {
      return this.getKey(this.logoConfig, "image.src", "");
    },
    logoClass() {
      return this.prefixStringKey(this.logoConfig, "image.class", {
        prefix: "logotype-clir ",
        defaut: "logotype-clir"
      });
    },
    logoAltText() {
      return this.prefixStringKey(this.logoConfig, "image.altText", {
        prefix: "Logo "
      });
    },
    logoDimensions() {
      return this.getKey(this.logoConfig, "image.dimensions", []);
    },
    logoDimensionsUnity() {
      return this.logoDimensions.length > 2 ? this.logoDimensions[2] : "rem";
    },
    logoHeight() {
      const height =
        this.logoDimensions.length > 1 ? this.logoDimensions[1].toString() : ``;
      return height.length ? `${height}${this.logoDimensionsUnity}` : ``;
    },
    logoWidth() {
      const width =
        this.logoDimensions.length > 1 ? this.logoDimensions[0].toString() : ``;
      return width.length ? `${width}${this.logoDimensionsUnity}` : ``;
    },
    logoStyle() {
      return this.logoWidth.length && this.logoHeight.length
        ? `width:${this.logoWidth};height:${this.logoHeight};`
        : ``;
    }
  }
};
</script>
<style scoped>
.bloc-entite-servicielle-clir {
  margin-bottom: 1.875rem !important;
}

.bloc-logotype-clir {
  margin-left: 1.25rem !important;
}

.bloc-entite-servicielle-clir,
.bloc-entite-servicielle-clir .bloc-marque-clir,
.bloc-entite-servicielle-clir img {
  min-height: 5rem !important;
  max-height: 7rem !important;
  height: auto !important;
}

.bloc-entite-servicielle-clir .bloc-logotype-clir {
  min-height: 4rem !important;
  max-height: 6rem !important;
  height: auto !important;
}

.bloc-entite-servicielle-clir-sm {
  margin-bottom: 0.5rem !important;
  max-width: 20rem !important;
}

.bloc-entite-servicielle-clir-sm,
.bloc-entite-servicielle-clir-sm .bloc-marque-clir,
.bloc-entite-servicielle-clir-sm .bloc-logotype-clir,
.bloc-entite-servicielle-clir-sm img {
  min-height: 2.5rem !important;
  max-height: 2.5rem !important;
  height: 2.5rem !important;
}

.no-link {
  cursor: default !important;
}
a,
a:hover {
  text-decoration: none;
}
</style>